"use client"

import type React from "react"
import { Row, Col } from "reactstrap"
import type { StaffDashboardData } from "./staff-dashboard"
import "../../CommonElements/DashboardTheme/dashboard-theme.css"

interface StaffDashboardStatsProps {
  data: StaffDashboardData | null
  loading: boolean
}

const StaffDashboardStats: React.FC<StaffDashboardStatsProps> = ({ data, loading }) => {
  const statsCards = [
    {
      title: "Active Exhibitors",
      value: data?.active_exhibitors_count || 0,
      icon: "fa-users",
      accent: "indigo" as const,
      description: "Currently registered exhibitors",
    },
    {
      title: "Total Exhibitions",
      value: data?.staff_stats.total_exhibitions || 0,
      icon: "fa-calendar",
      accent: "emerald" as const,
      description: "All active exhibitions",
    },
    {
      title: "Upcoming Events",
      value: data?.staff_stats.upcoming_exhibitions || 0,
      icon: "fa-clock-o",
      accent: "amber" as const,
      description: "Future exhibitions scheduled",
    },
    {
      title: "Past Events",
      value: data?.staff_stats.past_exhibitions || 0,
      icon: "fa-history",
      accent: "cyan" as const,
      description: "Completed exhibitions",
    },
  ]

  return (
    <Row className="g-3">
      {statsCards.map((stat, index) => (
        <Col lg="3" md="6" key={index}>
          <div className="db-kpi-card">
            {loading ? (
              <div className="d-flex align-items-center">
                <div className="db-skeleton rounded-circle me-3" style={{ width: "42px", height: "42px" }}></div>
                <div className="flex-grow-1">
                  <div className="db-skeleton mb-2" style={{ height: "12px", width: "80%" }}></div>
                  <div className="db-skeleton mb-2" style={{ height: "26px", width: "60%" }}></div>
                  <div className="db-skeleton" style={{ height: "10px", width: "90%" }}></div>
                </div>
              </div>
            ) : (
              <div className="db-kpi-top">
                <div className="flex-grow-1 me-2">
                  <div className="db-kpi-eyebrow">{stat.title}</div>
                  <div className="db-kpi-value">{stat.value.toLocaleString()}</div>
                  <div className="db-kpi-sub">{stat.description}</div>
                </div>
                <div className={`db-kpi-chip db-accent-${stat.accent}`}>
                  <i className={`fa ${stat.icon}`}></i>
                </div>
              </div>
            )}
          </div>
        </Col>
      ))}
    </Row>
  )
}

export default StaffDashboardStats
